// import i18n from '@/plugins/i18n'

export default [
  // {
  //   portalGroup: 'collab.public',
  //   path: 'search/:type?',
  //   name: 'Search',
  //   component: () => import('./PgSearch')
  // },
  {
    portalGroup: 'collab.public',
    path: 'search',
    name: 'Search',
    component: () => import('./PgSearchTVP')
  }
]
